import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { CenterOlPaymentsCreatePage } from './center-ol-payments-create'
import { CenterOlPaymentsListPage } from './center-ol-payments-list'
import { CenterOlPaymentsUpdatePage } from './center-ol-payments-update'

export const centerOlPaymentsRoutes: Route[] = [
  {
    path: Paths.CENTER_OL_PAYMENTS_LIST_PAGE,
    element: <CenterOlPaymentsListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CENTER_OL_PAYMENTS_CREATE_PAGE,
    element: <CenterOlPaymentsCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CENTER_OL_PAYMENTS_UPDATE_PAGE,
    element: <CenterOlPaymentsUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]
